import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { sitemapRoutes } from 'data/sitemapRoute';

const exceptionPaths = ['/review/post', '/review/apply', '/notice', '/guide'];

const getSeoData = targetPath => {
	const exceptedPath = exceptionPaths.find(
		exceptionPath =>
			targetPath &&
			typeof targetPath === 'string' &&
			targetPath.includes(exceptionPath),
	);

	// find()가 undefined를 반환하면 즉시 구조분해에서 터지므로 기본값으로 방어한다.
	const matched = sitemapRoutes.find(
		({ path: sitemapPath }) => sitemapPath === (exceptedPath || targetPath),
	);

	return { title: matched?.title ?? 'Netplace', desc: matched?.desc ?? '' };
};

const targetMetaTags = ['description', 'og:title', 'og:description'];

const Seo = () => {
	const location = useLocation();

	const [seoData, setSeoData] = useState({ title: '', desc: '' });
	const checkSeoData = pathname => {
		setSeoData(getSeoData(pathname));
	};

	useEffect(() => {
		checkSeoData(location.pathname);
	}, [location.pathname]);

	useEffect(() => {
		if (!seoData.title) return;

		document.title = seoData.title;

		// getElementsByTagName('meta')는 문서 전체를 스캔하므로 <head> 밖의 meta가
		// 걸리면 document.head.removeChild()가 NotFoundError를 던진다.
		// <head> 범위로 한정하고, 부모를 가정하지 않는 node.remove()를 사용한다.
		const selector = targetMetaTags
			.map(name => `meta[name="${name}"]`)
			.join(', ');
		document.head.querySelectorAll(selector).forEach(metaTag => {
			metaTag.remove();
		});

		targetMetaTags.forEach(name => {
			const newMetaTag = document.createElement('meta');
			newMetaTag.setAttribute('name', name);
			newMetaTag.setAttribute(
				'content',
				name === 'og:title' ? seoData.title : seoData.desc,
			);
			document.head.append(newMetaTag);
		});
	}, [seoData]);

	return (
		<Helmet>
			<title>{seoData.title}</title>
			{/* 다른 <meta/> 추가 적용 */}
		</Helmet>
	);
};

export default Seo;
